<h1 class="t-heading" *ngIf="heading">{{ heading }}</h1>
<ng-content></ng-content>
<table class="t-table">
  <tr class="t-row t-row_header">
    <th class="t-th t-cell t-cell_prop t-name" [ngSwitch]="success$ | async">
      <span
        class="indicator"
        *ngSwitchCase="true"
        prizmHint="We have found all necessarily inputs and outputs."
      >
        <prizm-indicator type="icon" status="success"></prizm-indicator>
      </span>
      <span
        class="indicator"
        *ngSwitchCase="false"
        prizmHint="We have not found all necessarily inputs and outputs. Please add this!"
      >
        <prizm-indicator type="icon" status="danger"></prizm-indicator>
      </span>
      {{ texts[2] }}
    </th>
    <th class="t-th">{{ type }}</th>
    <th class="t-th t-cell t-cell_value" *ngIf="showValues && !isAPI">{{ texts[3] }}</th>
  </tr>
  <tr
    class="t-row"
    *ngFor="
      let propertyConnector of propertiesConnectors
        | prizmCallFunc : updateOnChanges : propertiesInnerConnectors
        | async;
      let idx = index
    "
    [class.t-deprecated]="propertyConnector.documentationPropertyDeprecated"
  >
    <td class="t-cell">
      <div class="t-property" automation-id="tui-documentation__property-name">
        {{ stripOptional(propertyConnector.attrName) }}
        <tui-badge *ngIf="isOptional(propertyConnector.attrName)" size="s" value="Optional"></tui-badge>
      </div>
      <span class="t-deprecated-label" *ngIf="propertyConnector.documentationPropertyDeprecated">
        deprecated
      </span>
      <ng-container [ngTemplateOutlet]="propertyConnector.template"></ng-container>
    </td>
    <td class="t-cell">
      <span class="type" *prizmLet="getType(propertyConnector) as type">
        {{ type }}
        <tui-tooltip
          *ngIf="showContentTooltip(type)"
          [describeId]="propertyConnector.attrName"
          [content]="content"
        >
          <ng-template #content>
            {{ texts[4] }}
            <a tuiLink tuiMode="onDark" target="_blank" href="/tools/polymorph">
              <b>PolymorphModule</b>
            </a>
          </ng-template>
        </tui-tooltip>
      </span>
    </td>
    <td class="t-cell" *ngIf="showValues">
      <ng-container *ngIf="propertyConnector.shouldShowValues; else elseEmitter">
        <tui-select
          *ngIf="propertyConnector.hasItems; else noItems"
          [tuiTextfieldCleaner]="showCleaner(propertyConnector.documentationPropertyType)"
          [tuiTextfieldLabelOutside]="true"
          [nativeId]="propertyConnector.attrName"
          [valueContent]="selectContent"
          [ngModel]="propertyConnector.documentationPropertyValue"
          (ngModelChange)="propertyConnector.onValueChange($event)"
          tuiTextfieldSize="m"
          tuiDropdownLimitWidth="min"
        >
          <code class="t-exception">null</code>
          <tui-data-list-wrapper
            *tuiDataList
            [items]="propertyConnector.documentationPropertyValues"
            [itemContent]="selectContent"
          ></tui-data-list-wrapper>
        </tui-select>
        <ng-template #selectContent let-data>
          <code>{{ data | prizmCallFunc : inspectAny }}</code>
        </ng-template>

        <ng-template #noItems>
          <ng-container [ngSwitch]="propertyConnector.documentationPropertyType">
            <tui-toggle
              *ngSwitchCase="'boolean'"
              [nativeId]="propertyConnector.attrName"
              [showIcons]="true"
              [ngModel]="propertyConnector.documentationPropertyValue"
              (ngModelChange)="propertyConnector.onValueChange($event)"
              size="l"
            ></tui-toggle>

            <tui-primitive-textfield
              *ngSwitchCase="'string'"
              [nativeId]="propertyConnector.attrName"
              [tuiTextfieldLabelOutside]="true"
              [tuiTextfieldCleaner]="true"
              [value]="propertyConnector.documentationPropertyValue || ''"
              (valueChange)="propertyConnector.onValueChange($event)"
              tuiTextfieldSize="m"
            ></tui-primitive-textfield>

            <!--            TODO !ng16 add feature to change defined templates/components/numbers when polymorh does not value-->
            <!--         ngIf trigger move to prizmLet or code for avoid unnecessary invokes   -->
            <tui-primitive-textfield
              *ngIf="showPolymorph(propertyConnector)"
              [nativeId]="propertyConnector.attrName"
              [tuiTextfieldLabelOutside]="true"
              [tuiTextfieldCleaner]="true"
              [value]="propertyConnector.documentationPropertyValue || ''"
              (valueChange)="propertyConnector.onValueChange($event)"
              tuiTextfieldSize="m"
            ></tui-primitive-textfield>

            <div *ngSwitchCase="'color'" tuiGroup>
              <tui-primitive-textfield
                [attr.id]="propertyConnector.attrName"
                [tuiTextfieldLabelOutside]="true"
                [prizmInputOpacity]="getOpacity(propertyConnector.documentationPropertyValue)"
                [value]="getColor(propertyConnector.documentationPropertyValue)"
                (valueChange)="onColorChange(propertyConnector, $event)"
                tuiTextfieldSize="m"
              >
                <input tuiTextfield type="text" />
              </tui-primitive-textfield>
              <tui-input-count
                [max]="100"
                [ngModel]="getOpacity(propertyConnector.documentationPropertyValue)"
                (ngModelChange)="onOpacityChange(propertyConnector, $event)"
                tuiTextfieldSize="m"
              >
                Opacity
              </tui-input-count>
            </div>

            <tui-input-count
              *ngSwitchCase="'number'"
              [nativeId]="propertyConnector.attrName"
              [tuiTextfieldLabelOutside]="true"
              [ngModel]="propertyConnector.documentationPropertyValue"
              (ngModelChange)="propertyConnector.onValueChange($event)"
              tuiTextfieldSize="m"
            ></tui-input-count>

            <ng-container *ngSwitchDefault>
              <tui-primitive-textfield
                *ngIf="propertyConnector.documentationPropertyMode === 'ng-content'"
                [nativeId]="propertyConnector.attrName"
                [tuiTextfieldLabelOutside]="true"
                [tuiTextfieldCleaner]="true"
                [value]="propertyConnector.documentationPropertyValue || ''"
                (valueChange)="propertyConnector.onValueChange($event)"
                tuiTextfieldSize="m"
              ></tui-primitive-textfield>
            </ng-container>

            <tui-input-number
              *ngSwitchCase="'decimal'"
              [nativeId]="propertyConnector.attrName"
              [tuiTextfieldLabelOutside]="true"
              [ngModel]="propertyConnector.documentationPropertyValue"
              (ngModelChange)="propertyConnector.onValueChange($event)"
              tuiTextfieldSize="m"
            ></tui-input-number>
          </ng-container>
        </ng-template>
      </ng-container>

      <ng-template #elseEmitter>
        <tui-notification class="t-output" [@emitEvent]="propertyConnector.emits$ | async">
          Emit!
        </tui-notification>
      </ng-template>
    </td>
  </tr>
</table>

<ng-container *ngIf="hasTestId">
  <ng-template
    #testIdTemplate="documentationProperty"
    [documentationPropertyValue]="testIdPostfix"
    [documentationPropertyName]="testIdName"
    (documentationPropertyValueChange)="changeTestIdPostfix($event, $any(testIdTemplate.host))"
    documentationPropertyType="string"
    documentationPropertyMode="input"
  >
    Postfix for testId
  </ng-template>
</ng-container>
<ng-container *ngIf="control">
  <ng-template
    [documentationPropertyValue]="control | prizmCallFunc : isTouchedFromControl$ | async"
    (documentationPropertyValueChange)="setTouched(control, $any($event))"
    documentationPropertyName="touched"
    documentationPropertyType="boolean"
    documentationPropertyMode="form-control"
  >
    Touched
  </ng-template>

  <ng-template
    [documentationPropertyValue]="control | prizmCallFunc : isDirtyFromControl$ | async"
    (documentationPropertyValueChange)="setDirty(control, $any($event))"
    documentationPropertyName="dirty"
    documentationPropertyType="boolean"
    documentationPropertyMode="form-control"
  >
    Dirty
  </ng-template>

  <ng-template
    [documentationPropertyValue]="control | prizmCallFunc : isPristineFromControl$ | async"
    (documentationPropertyValueChange)="setPristine(control, $any($event))"
    documentationPropertyName="pristine"
    documentationPropertyType="boolean"
    documentationPropertyMode="form-control"
  >
    Pristine
  </ng-template>

  <ng-template
    [documentationPropertyValue]="control | prizmCallFunc : getDisabledFromControl$ | async"
    (documentationPropertyValueChange)="updateStateOfControl(control, $any($event))"
    documentationPropertyName="disabled"
    documentationPropertyType="boolean"
    documentationPropertyMode="form-control"
  >
    Change disabled state of control
  </ng-template>

  <ng-template
    [documentationPropertyValue]="control | prizmCallFunc : getValueFromControl$ | async"
    (documentationPropertyValueChange)="updateValueOfControl(control, $any($event))"
    documentationPropertyName="value"
    documentationPropertyType="string"
    documentationPropertyMode="form-control"
  >
    Value
  </ng-template>

  <ng-template
    [documentationPropertyValue]="control | prizmCallFunc : getRequiredFromControl$ | async"
    (documentationPropertyValueChange)="updateRequiredValidatorOfControl(control, $any($event))"
    documentationPropertyName="required"
    documentationPropertyType="boolean"
    documentationPropertyMode="form-control"
  >
    Add required validator
  </ng-template>
</ng-container>
